import { Breadcrumbs, Stack, Typography } from '@mui/material'
import { LinkRouter } from 'components/breadcrumbs'
import { PopupMenu } from 'components/common/SubMenuPopup'
import FacilityConfigContext from 'contexts/FacilityConfigContext'
import { useModulePermission } from 'hooks/useModulePermission'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { IAssetPermissionsDataset } from 'types/common'
import { getKeyValueorDefault, getKeyValueOrDefaultNested } from 'utils/utils'

type iBarrierSubMenu = {
  audit_id?: string | undefined
  asset_name?: string
  pageOrigin?: 'assurance-scorecard' | 'hazard-barrier-evaluation' | 'action-management'
}

export default function BarrierSubMenu({ audit_id, asset_name, ...props }: iBarrierSubMenu) {
  const { project_id } = useParams()

  const { config } = useContext(FacilityConfigContext)
  const { checkProjectPermission } = useModulePermission()

  const showBarrierManagement = checkProjectPermission({
    action: 'BarrierManagement:GetModuleAccess',
    type: 'read',
  })

  const showProcessSafetyElements = checkProjectPermission({
    action: 'ProcessIntegrity:GetModuleAccess',
    type: 'read',
  })
  const showAssuranceScorecard = checkProjectPermission({
    action: 'AssuranceScorecard:GetModuleAccess',
    type: 'read',
  })
  const showActionManagement = checkProjectPermission({
    action: 'ActionManagement:GetModuleAccess',
    type: 'read',
  })

  const showAssuranceScorecardKPISetup = checkProjectPermission({
    action: ['AssuranceScorecard:CreateUpdateKPIGroup', 'AssuranceScorecard:CreateUpdateProjectThreshold'],
    type: 'write',
  })
  const showActionManagementActionLoadsheet = checkProjectPermission({
    action: ['ActionManagement:BatchCreateUpdateAssessmentFormAction', 'ActionManagement:BatchDownloadAssessmentFormAction'],
    type: ['list', 'write'],
  })

  

  const subMenuContext = [
    {
      label: 'Barrier Management',
      enabled: (showBarrierManagement),
      items: [
        {
          label: 'Project Dashboard',
          url: `/hazard-barrier-evaluation/project/${project_id}/`,
          disabled: !showBarrierManagement,
        },
      ],
    },
    {
      label: getKeyValueOrDefaultNested(config, 'PSE_LABEL.TITLE_SECONDARY', 'Process Integrity'),
      enabled: (showProcessSafetyElements),
      items: [
        {
          label: 'Project Dashboard',
          url: `/process-safety-elements/project/${project_id}/`,
          disabled: !showProcessSafetyElements,
        },
      ],
    },
    {
      label: 'Assurance Scorecard',
      enabled: (showAssuranceScorecard || showAssuranceScorecardKPISetup),
      items: [
        {
          label: 'Project Dashboard',
          url: `/assurance-scorecard/project/${project_id}/`,
          disabled: !showAssuranceScorecard,
        },
        {
          label: 'KPI Setup',
          url: `/assurance-scorecard/project/${project_id}/kpi-setup`,
          disabled: !showAssuranceScorecardKPISetup,
        },
      ],
    },
    {
      label: 'Action Management',
      enabled: (showActionManagement || showActionManagementActionLoadsheet),
      items: [
        {
          label: 'Action Management',
          url: `/action-management/project/${project_id}/`,
          disabled: !showActionManagement,
        },
        {
          label: 'Loadsheet',
          url: `/action-management/project/${project_id}/action-management/action-loadsheet`,
          disabled: !showActionManagementActionLoadsheet,
        },
      ],
    },
  ]

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      display={'flex'}
      alignContent={'center'}
      className="sub-menu-bar"
      sx={{ paddingBottom: 2, backgroundColor: '#0070B4', paddingLeft: 3, borderColor: 'white' }}
    >
      <Breadcrumbs separator={<></>} sx={{ paddingLeft: 3, paddingTop: 2 }}>
        {subMenuContext && subMenuContext.map((item, index) => (
          <PopupMenu
            label={item.label}
            items={item.items}
            key={index}
          />
        ))}
      </Breadcrumbs>
    </Stack>
  )
}
